import { render, staticRenderFns } from "./NeckShoulderPain.vue?vue&type=template&id=78f659eb&scoped=true"
import script from "./NeckShoulderPain.vue?vue&type=script&lang=js"
export * from "./NeckShoulderPain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78f659eb",
  null
  
)

export default component.exports